import { Box, Tab, Tabs, Typography } from "@mui/material";
import { FC, useState } from "react";
import { Colors } from "../../../configs";
import { pxToRem } from "../../../util";

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface ICustomTab {
  label: string;
  content: JSX.Element;
  disabled?: boolean;
}
export interface ICustomTabContainerProps {
  tabs: ICustomTab[];
  outsideConrol?: {
    selectedTab: number;
    changeTab: (tab: number) => void;
  };
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const CustomTabContainer: FC<ICustomTabContainerProps> = ({
  tabs,
  outsideConrol = null,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    if (outsideConrol) {
      outsideConrol.changeTab(newValue);
    } else {
      setSelectedTab(newValue);
    }
  };

  return (
    <>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <Tabs
          value={outsideConrol ? outsideConrol.selectedTab : selectedTab}
          onChange={handleChangeTab}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
          sx={{
            minHeight: 0,
            "& .MuiTabs-flexContainer": {
              alignItems: "stretch",
            },
            "& .MuiTab-root": {
              background: Colors.BACKSHADE_GRAY,
              color: Colors.PRIMARY,
              height: pxToRem(46),
              minHeight: pxToRem(46),
              width: "13.9285714286rem",
              whiteSpace: "nowrap",
              textTransform: "none",
              fontWeight: "medium",
              marginBottom: "-1px",
              mt: 1,
            },
            "& .Mui-selected": {
              background: Colors.PRIMARY,
              color: `${Colors.WHITE} !important`,
            },
            "& .MuiTab-root:first-of-type": {
              borderRadius: "0.71rem 0 0 0",
            },
            "& .MuiTab-root:nth-of-type(2)": {
              borderRadius: "0 0.71rem 0 0",
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              disabled={tab.disabled}
              label={tab.label}
              sx={{ textTransform: "capitalize", fontSize: "1.3rem" }}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel
          value={outsideConrol ? outsideConrol.selectedTab : selectedTab}
          index={index}
        >
          {tab.content}
        </CustomTabPanel>
      ))}
    </>
  );
};

export default CustomTabContainer;
